var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 786 510",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "hoverable",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3904 289.515C33.2575 279.742 37.833 269.735 46.6198 264.954L484.907 26.492C495.822 20.5532 509.485 24.5875 515.424 35.5029C521.363 46.4183 517.329 60.0813 506.413 66.0201L135.984 267.562L650.713 302.902C663.11 303.753 672.47 314.493 671.619 326.89C670.768 339.287 660.028 348.647 647.63 347.796L55.8318 307.165C45.8521 306.48 37.5232 299.288 35.3904 289.515Z",
    fill: "url(#paint0_linear_279_228)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M750.46 220.484C752.593 230.258 748.017 240.265 739.231 245.046L300.943 483.508C290.028 489.447 276.365 485.412 270.426 474.497C264.487 463.581 268.522 449.918 279.437 443.98L649.866 242.438L135.138 207.098C122.74 206.247 113.38 195.507 114.232 183.11C115.083 170.713 125.823 161.353 138.22 162.204L730.019 202.835C739.998 203.52 748.327 210.711 750.46 220.484Z",
    fill: "url(#paint1_linear_279_228)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_279_228",
    x1: 363.84,
    y1: 43.5444,
    x2: 533.444,
    y2: 294.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BF4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002BDC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_279_228",
    x1: 454.8,
    y1: 393.88,
    x2: 328.495,
    y2: 182.017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BF4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002BDC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon);
export default __webpack_public_path__ + "static/media/NavIcon.6d8de15e44dee3a7f1987ded2c31c5bc.svg";
export { ForwardRef as ReactComponent };